import { Injectable, signal, WritableSignal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {
  private _isVisible = signal(false);
  isVisible = this._isVisible.asReadonly();

  private _type = signal('error');
  type = this._type.asReadonly();

  private _messageContent = signal('');
  messageContent = this._messageContent.asReadonly();

  private _title = signal('');
  title = this._title.asReadonly();

  private _icon = signal('');
  icon = this._icon.asReadonly();

  private timeoutId: any = 3000;

  constructor() { }

  show(title:string, message:string, duration: number = 3000, type: string): void {
    this._title.set(title);
    this._messageContent.set(message);
    this._type.set(type);
    this._isVisible.set(true);
    this.setIcon(type);
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.timeoutId = setTimeout(() => {
      this.hide();
    }, duration);
  }

  hide(): void {
    this._type.set('');
    this._title.set('');
    this._messageContent.set('');
    this._isVisible.set(false);
    this.timeoutId = 3000;
  }

  setIcon(icon:string) {
    switch (icon) {
      case 'success':
        this._icon.set('progress-check');
        break;
      case 'error':
        this._icon.set('exclamation-circle');
        break;
      case 'warning':
        this._icon.set('alert-triangle');
        break;
      case 'info':
        this._icon.set('info-circle');
        break;
    }
  }

  success(title:string, message:string, duration: number = 3000){
    this.show(title, message, duration, 'success');
  }
  warning(title:string, message:string, duration: number = 3000){
    this.show(title, message, duration, 'warning');
  }

  error(title:string, message:string, duration: number = 3000){
    this.show(title, message, duration, 'error');
  }

  info(title:string, message:string, duration: number = 3000){
    this.show(title, message, duration, 'info');
  }
}
